module.exports = {
    "Clear search": `Tyhjenn\xe4 haku`
};


//# sourceMappingURL=fi-FI.main.js.map
